// extracted by mini-css-extract-plugin
export default {"header":"AdminHeader_header__-ufK0","mobileHeader":"AdminHeader_mobileHeader__-khN2","headerLogo":"AdminHeader_headerLogo__fVPuq","backLink":"AdminHeader_backLink__6vfey"};